// extracted by mini-css-extract-plugin
export var barlowFont = "home-module--barlow-font--9KFfN";
export var zoom = "home-module--zoom--Ey3Vm";
export var comapnytext = "home-module--comapnytext--ED5jO";
export var hometext = "home-module--hometext--25eBZ";
export var circle = "home-module--circle--1AQ0l";
export var scrollposition = "home-module--scrollposition--3yEOd";
export var scroll = "home-module--scroll--L8Qvd";
export var bounce = "home-module--bounce--Eh4St";